import {InjectionToken} from '@angular/core'
import {OutletEmbeddedService} from '@service/outlet/outlet.embedded.service'
import {OutletService} from '@service/outlet/outlet.service'
import type {EmbeddedClientService} from '@service/embeddingService/embedded-client.service'

/**
 * Factory que resuelve la implementación adecuada de `OutletService`.
 *
 * @description
 * Devuelve `OutletEmbeddedService` en modo embebido y `OutletService`
 * en modo standalone. `OutletService` es la puerta de entrada de dominio
 * para consultar los puntos de venta (outlets), su detalle y sus
 * relaciones con visitas, pedidos y tareas.
 *
 * @param embeddedClientService Cliente que detecta si la app corre embebida.
 * @returns Instancia activa de `OutletService`.
 */
export function providerOutletServiceFactory(embeddedClientService: EmbeddedClientService) {
  if (embeddedClientService.isEmbeddedFunction()) {
    return new OutletEmbeddedService()
  }
  return new OutletService()
}

/**
 * `InjectionToken` que referencia la instancia activa de `OutletService`.
 *
 * @description
 * Registrado en `SERVICE_PROVIDERS` junto con
 * {@link providerOutletServiceFactory}.
 */
export const OutletServiceToken = new InjectionToken<OutletService>('OutletService')
